import React from 'react';

import type { SalesPromotionContactDto } from '@/services/ws-funnel/src/main/resources/rest-api';
import { getSalesPromotionContacts } from '@/services/ws-funnel/src/main/resources/rest-api';
import type { IdSalesPromotionDto } from '@/services/ws-funnel/src/main/resources/rest-api/types';
import { useRequestLegacy } from '@/js/libs/use-request-legacy';

type UsePromotionContacts = {
  contacts: SalesPromotionContactDto[];
  isLoading: boolean;
  reload: () => void;
};

export const usePromotionContacts = (salesPromotionId: IdSalesPromotionDto): UsePromotionContacts => {
  const [{ items: contacts }, { pending: isLoading }, reload] = useRequestLegacy({
    apiMethod: getSalesPromotionContacts,
    parameters: [{ salesPromotionId }],
    defaultData: { items: [], total: 0 },
  });
  return React.useMemo<UsePromotionContacts>(() => ({ contacts, isLoading, reload }), [contacts, isLoading, reload]);
};
